// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"12a6ebaaca1aea4bf90b","655":"bc23c298cb5e7ac93db8"}[chunkId] + ".js";
};